/**
 * 멤버 인증 입력 공용 검증·프레임.
 * - 명단 입장: 번호 + 개인 입장번호(6자리)만 — 별칭 없음(교사 화면에는 번호와 교사 쪽 명단 이름으로 표시)
 * - 방 입장번호(명단 없음): 화면에 보일 이름 + 방 입장번호
 * 서버 쪽 대응: cloudflare/realtime/src/memberAuth.ts
 * 지금은 학생 기기 연결(CommStudentPage)에서 쓰고, 나중에 반 고정 멤버 링크에서도 재사용한다.
 */
export type MemberEntryValues = { number: string; nickname: string; code: string };

/** rosterMode=true: 번호 + 개인 입장번호(6자리) / false: 이름 + 방 입장번호(4~8자리) */
export function validateMemberEntry(v: MemberEntryValues, rosterMode: boolean): string | null {
  if (rosterMode) {
    const no = Number(v.number.trim());
    if (!(Number.isInteger(no) && no >= 1 && no <= 9999)) return '내 번호를 입력해 주세요.';
    if (!/^\d{6}$/.test(v.code.trim())) return '입장번호 6자리를 입력해 주세요.';
    return null;
  }
  if (!v.nickname.trim()) return '이름을 입력해 주세요.';
  if (!/^\d{4,8}$/.test(v.code.trim())) return '입장번호(숫자)를 입력해 주세요.';
  return null;
}

/** 서버 join 프레임 (검증 통과 후 호출) */
export function buildMemberJoinFrame(v: MemberEntryValues, rosterMode: boolean): Record<string, unknown> {
  return rosterMode
    ? { t: 'join', number: Number(v.number.trim()), entry: v.code.trim() }
    : { t: 'join', nickname: v.nickname.trim(), code: v.code.trim() };
}

/** 서버 오류 코드 → 안내 문구 */
export const MEMBER_ENTRY_ERRORS: Record<string, string> = {
  wrong_code: '입장번호가 맞지 않아요.',
  nickname_taken: '이미 쓰고 있는 이름이에요. 다른 이름을 써 주세요.',
  full: '정원(30명)이 다 찼어요.',
  locked: '잘못된 입장번호가 너무 많아 잠시 잠겼어요. 조금 뒤에 다시 시도해 주세요.',
  bad_nickname: '이름을 입력해 주세요.',
  reentry_required: '입장번호가 바뀌었어요. 선생님께 받은 새 입장번호로 다시 들어와 주세요.',
};
